module.exports = __webpack_public_path__ + "img/testimonials-photo.cb67db4a.png";